export default __webpack_public_path__ + "static/media/CAL70250.7d838e43.jpg";